<!-- 1. Default button -->
<!-- Angular routerlink conditionally -->
<!-- https://stackoverflow.com/questions/36753819/conditionally-add-routerlink-or-other-attribute-directives-to-an-element-in-angu -->
@if (component === 'Button') {
  <button
    [routerLink]="routerPath ? routerPath : []"
    [class]="class"
    [style]="style"
    [ngClass]="{
      bg: true,
      'bg--mob-mode': mobMode,
      'bg--in-cart': styleName === 'in cart',
      'bg--active': styleName === 'active category',
      'bg--color-customizer': styleName === 'color customizer',
      'bg--center': styleName === 'center',
      'bg--center-grey': styleName === 'center-grey',
      'bg--download-dropdown': styleName === 'download-dropdown',
      'bg--track': styleName === 'track',
      'bg--dropdown-active': styleName === 'dropdown-active',
      'bg--right': styleName === 'right',
      'bg--grey': styleName === 'grey',
      'bg--icon-40': styleName === 'icon-40',
      'bg--icon-40-column-gap-4': styleName === 'icon-40-column-gap-4',
      'theme-btn__newsLetterBlock': themeBtnClass === 'theme-btn__newsLetterBlock',
      'theme-btn__contactsBlock': themeBtnClass === 'theme-btn__contactsBlock',
      'theme-btn__beatsBlock': themeBtnClass === 'theme-btn__beatsBlock',
      'theme-btn__licenseBlock-showAllBeats': themeBtnClass === 'theme-btn__licenseBlock-showAllBeats',
      'theme-btn__licenseBlock-goToCart': themeBtnClass === 'theme-btn__licenseBlock-goToCart',
      'theme-btn__licenseBlock-addToCart': themeBtnClass === 'theme-btn__licenseBlock-addToCart',
      'theme-btn__beatsBlock-buy': themeBtnClass === 'theme-btn__beatsBlock-buy',
      'theme-btn__beatsBlock-inCart': themeBtnClass === 'theme-btn__beatsBlock-inCart',
      'theme-btn__license-popUp': themeBtnClass === 'theme-btn__license-popUp',
      'theme-btn__headerBlockBeatPage-btnGoToCart': themeBtnClass === 'theme-btn__headerBlockBeatPage-btnGoToCart',
      'theme-btn__headerBlockBeatPage-btnBuy': themeBtnClass === 'theme-btn__headerBlockBeatPage-btnBuy',
      'theme-btn__cartPopup-btnGoToPayment': themeBtnClass === 'theme-btn__cartPopup-btnGoToPayment',
      'theme-btn__cartPage-btnCoupon': themeBtnClass === 'theme-btn__cartPage-btnCoupon',
      'theme-btn__cartPage-disabledBtnCoupon': themeBtnClass === 'theme-btn__cartPage-disabledBtnCoupon',
      'theme-btn__cartPagePaymentBlock-btnConfirm': themeBtnClass === 'theme-btn__cartPagePaymentBlock-btnConfirm',
      'theme-btn__shareTrackPopup-btnCopyLink': themeBtnClass === 'theme-btn__shareTrackPopup-btnCopyLink',
      'theme-btn__shareTrackPopup-btnLinkCopied': themeBtnClass === 'theme-btn__shareTrackPopup-btnLinkCopied',
      'theme-btn__player-btnGoToCart': themeBtnClass === 'theme-btn__player-btnGoToCart',
      'theme-btn__player-btnBuy': themeBtnClass === 'theme-btn__player-btnBuy',
      'theme-btn__counter-btnBuy': themeBtnClass === 'theme-btn__counter-btnBuy',
      'theme-btn__notFoundPage': themeBtnClass === 'theme-btn__notFoundPage',
      'theme-btn__cookieNotification': themeBtnClass === 'theme-btn__cookieNotification',
      'theme-btn__cartPage-btnBackToTracksPage': themeBtnClass === 'theme-btn__cartPage-btnBackToTracksPage'
    }"
    (click)="btnClickHandler($event)"
    [disabled]="disabled"
    [queryParams]="queryParams"
  >
    @if (title) {
      <span class="text">{{ title }}</span>
    }
    @if (icon) {
      <span
        class="btn-icon  {{ icon }}"
        [ngClass]="{
          'in-cart': styleName === 'in cart',
          'theme-icon__newsLetterBlock': themeIconClass === 'theme-icon__newsLetterBlock',
          'theme-icon__contactsBlock': themeIconClass === 'theme-icon__contactsBlock',
          'theme-icon__beatsBlock-buy': themeIconClass === 'theme-icon__beatsBlock-buy',
          'theme-icon__beatsBlock-inCart': themeIconClass === 'theme-icon__beatsBlock-inCart',
          'theme-icon__license-popUp': themeIconClass === 'theme-icon__license-popUp',
          'theme-icon__licenseBlock-showAllBeats': themeIconClass === 'theme-icon__licenseBlock-showAllBeats',
          'theme-icon__licenseBlock-goToCart': themeIconClass === 'theme-icon__licenseBlock-goToCart',
          'theme-icon__licenseBlock-addToCart': themeIconClass === 'theme-icon__licenseBlock-addToCart',
          'theme-icon__headerBlockBeatPage-btnIconGoToCart':
            themeIconClass === 'theme-icon__headerBlockBeatPage-btnIconGoToCart',
          'theme-icon__headerBlockBeatPage-btnIconBuy': themeIconClass === 'theme-icon__headerBlockBeatPage-btnIconBuy',
          'theme-icon__cartPopup-btnIconGoToPayment': themeIconClass === 'theme-icon__cartPopup-btnIconGoToPayment',
          'theme-icon__cartPage-btnCouponIcon': themeIconClass === 'theme-icon__cartPage-btnCouponIcon',
          'theme-icon__cartPage-disabledBtnCouponIcon': themeIconClass === 'theme-icon__cartPage-disabledBtnCouponIcon',
          'theme-icon__cartPagePaymentBlock-btnConfirmIcon':
            themeIconClass === 'theme-icon__cartPagePaymentBlock-btnConfirmIcon',
          'theme-icon__shareTrackPopup-btnCopyLinkIcon':
            themeIconClass === 'theme-icon__shareTrackPopup-btnCopyLinkIcon',
          'theme-icon__shareTrackPopup-btnLinkCopiedIcon':
            themeIconClass === 'theme-icon__shareTrackPopup-btnLinkCopiedIcon',
          'theme-icon__player-btnIconGoToCart': themeIconClass === 'theme-icon__player-btnIconGoToCart',
          'theme-icon__player-btnIconBuy': themeIconClass === 'theme-icon__player-btnIconBuy',
          'theme-icon__counter-btnBuy': themeIconClass === 'theme-icon__counter-btnBuy',
          'theme-icon__cartPage-btnBackToTracksPageIcon':
            themeIconClass === 'theme-icon__cartPage-btnBackToTracksPageIcon'
        }"
      >
      </span>
    }
    @if (isLoader) {
      <img [src]="'assets/images/loaders/loader-circle.svg' | bmAssetUrl" alt="circle loader" />
    }
    <ng-content></ng-content>
  </button>
}

<!-- 2. Link href -->
@if (component === 'LinkHref') {
  <a
    class="bg"
    href="{{ linkPath }}"
    target="_blank"
    [style]="style"
    [ngClass]="{
      'bg--download-dropdown': styleName === 'download-dropdown',
      'bg--track': styleName === 'track'
    }"
  >
    {{ title }}
    <span class="btn-icon  {{ icon }}"></span>
  </a>
}

<!-- 3. Link look like button -->
@if (component === 'LinkAsButton') {
  <a [routerLink]="routerPath" class="bg" [style]="style" [ngClass]="{ 'bg--track': styleName === 'track' }">
    {{ title }}
    <span class="btn-icon  {{ icon }}"></span>
  </a>
}
